module.exports = __webpack_public_path__ + "img/section3_bg.d093d7c6.gif";